export enum SignupRoles {
    HOMEOWNER = 'Homeowner',
    BOARD_MEMBER = 'Board Member',
    PROPERTY_MANAGER = 'Property Manager',
}
